import styled from 'styled-components'

export const AllMetricsContainer = styled.div`
  margin-bottom: 2.4rem;
`
